import { deleteUser } from "../../services/adminPanel_service";
import { toast } from "react-toastify";

const DeleteAdminModal = ({
  show,
  selectedUser,
  onClose,
  onSuccess
}) => {

  if (!show || !selectedUser) return null;

  const handleDelete = async () => {
    try {
      await deleteUser(selectedUser);
      toast.success("User Deleted successfully")
      onSuccess && onSuccess();
      onClose();
    } catch (err) {
      toast.error("Failed to Delete User.");
    }
  };

  return (
    <>
      <div className="modal fade in" style={{ display: "block" }}>
        <div className="modal-dialog" style={{ width: "500px" }}>
          <div className="modal-content">

            {/* HEADER */}
            <div
              className="modal-header"
              style={{ padding: "0px 0px" }}
            >
              <button
                type="button"
                className="close"
                onClick={onClose}
              >
                &times;
              </button>
              <h4
                className="modal-title"
                style={{ margin: 0 }}
              >
                Confirm Delete
              </h4>
            </div>

            {/* BODY */}
            <div className="modal-body">
              <p>
                Are you sure you want to delete user:
                <strong> {selectedUser.userName}</strong> ?
              </p>
            </div>

            {/* FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDelete}
              >
                Delete
              </button>

              <button
                type="button"
                className="btn btn-default"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>

          </div>
        </div>
      </div>

      {/* Backdrop intentionally commented */}
      {/*
      <div className="modal-backdrop fade in" onClick={onClose} />
      */}
    </>
  );
};

export default DeleteAdminModal;